import React, { useState, useEffect } from "react";
import { Container, Row, Col, Card, Form, Button } from "react-bootstrap";
import axios from "axios";
import { toast } from "react-toastify";
import DepartmentTopbar from "../SuperAdmin/components/DepartmentTopbar";
import DepartmentSidebar from "../SuperAdmin/components/DepertmentSidebar";

function CreateTradeLicense() {
  const [tradeTypes, setTradeTypes] = useState([]);
  const [formData, setFormData] = useState({
    tradeName: "",
    ownerName: "",
    address: "",
    holdingNo: "",
    phoneNo: "",
    tradeTypeId: "",
    approxArea: "",
    registrationNumber: "",
  });

  const API_URL = process.env.REACT_APP_SUPER_ADMIN_API_URL;
  const token = localStorage.getItem("token");

  useEffect(() => {
    const fetchTradeTypes = async () => {
      try {
        const response = await axios.get(`${API_URL}list-all-trade-types.php`, {
          headers: { Authorization: `Bearer ${token}` },
        });
        if (response.data.status && Array.isArray(response.data.data)) {
          setTradeTypes(response.data.data);
        } else {
          toast.error("Could not load trade types for the dropdown.");
        }
      } catch (error) {
        toast.error("Failed to fetch trade types.");
      }
    };
    fetchTradeTypes();
  }, [API_URL, token]);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData({ ...formData, [name]: value });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    const apiPayload = {
      trade_name: formData.tradeName,
      trade_owner: formData.ownerName,
      address: formData.address,
      phone: formData.phoneNo,
      trade_type_id: formData.tradeTypeId,
      approx_area: formData.approxArea,
    };

    if (formData.holdingNo) {
      apiPayload.holding_no = formData.holdingNo;
    }
    if (formData.registrationNumber) {
      apiPayload.reg_no = formData.registrationNumber;
    }

    try {
      const response = await axios.post(
        `${API_URL}add-trade-license.php`,
        apiPayload,
        {
          headers: {
            Authorization: `Bearer ${token}`,
            "Content-Type": "application/json",
          },
        }
      );

      if (response.data.success) {
        toast.success(
          response.data.message || "Trade License Created Successfully!"
        );
        setFormData({
          tradeName: "",
          ownerName: "",
          address: "",
          holdingNo: "",
          phoneNo: "",
          tradeTypeId: "",
          approxArea: "",
          registrationNumber: "",
        });
      } else {
        toast.error(response.data.message || "Failed to create trade license.");
      }
    } catch (error) {
      toast.error("An error occurred while submitting the form.");
    }
  };

  return (
    <>
      <DepartmentTopbar />
      <div className="d-flex">
        <DepartmentSidebar />
        <Container fluid className="p-4 bg-light">
          <header className="mb-4">
            <h1 className="h3">Create New Trade License</h1>
          </header>

          <Row>
            <Col>
              <Card className="shadow-sm">
                <Card.Header
                  as="h5"
                  style={{
                    backgroundColor: "#e3f2fd",
                    borderBottom: "2px solid #1976d2",
                  }}
                >
                  <span style={{ color: "#1976d2" }}>
                    Trade License Entry Form
                  </span>
                </Card.Header>
                <Card.Body>
                  <Form onSubmit={handleSubmit}>
                    <Row className="mb-3">
                      <Form.Group as={Col} md="6" controlId="tradeName">
                        <Form.Label>Trade Name</Form.Label>
                        <Form.Control
                          type="text"
                          name="tradeName"
                          value={formData.tradeName}
                          onChange={handleChange}
                          required
                        />
                      </Form.Group>

                      <Form.Group as={Col} md="6" controlId="ownerName">
                        <Form.Label>Owner Name</Form.Label>
                        <Form.Control
                          type="text"
                          name="ownerName"
                          value={formData.ownerName}
                          onChange={handleChange}
                          required
                        />
                      </Form.Group>
                    </Row>

                    <Form.Group className="mb-3" controlId="address">
                      <Form.Label>Address</Form.Label>
                      <Form.Control
                        as="textarea"
                        rows={3}
                        name="address"
                        value={formData.address}
                        onChange={handleChange}
                        required
                      />
                    </Form.Group>

                    <Row className="mb-3">
                      <Form.Group as={Col} md="6" controlId="holdingNo">
                        <Form.Label>Holding No (Optional)</Form.Label>
                        <Form.Control
                          type="text"
                          name="holdingNo"
                          value={formData.holdingNo}
                          onChange={handleChange}
                        />
                      </Form.Group>

                      <Form.Group as={Col} md="6" controlId="phoneNo">
                        <Form.Label>Phone No</Form.Label>
                        <Form.Control
                          type="text"
                          name="phoneNo"
                          value={formData.phoneNo}
                          onChange={handleChange}
                          required
                        />
                      </Form.Group>
                    </Row>

                    <Row className="mb-3">
                      <Form.Group as={Col} md="4" controlId="tradeTypeId">
                        <Form.Label>Trade Type</Form.Label>
                        <Form.Control
                          as="select"
                          name="tradeTypeId"
                          value={formData.tradeTypeId}
                          onChange={handleChange}
                          required
                        >
                          <option value="">Select...</option>
                          {tradeTypes.map((type) => (
                            <option key={type.id} value={type.id}>
                              {type.trade_type_name}
                            </option>
                          ))}
                        </Form.Control>
                      </Form.Group>

                      <Form.Group as={Col} md="4" controlId="approxArea">
                        <Form.Label>Approx Area (sq. ft.)</Form.Label>
                        <Form.Control
                          type="number"
                          name="approxArea"
                          value={formData.approxArea}
                          onChange={handleChange}
                        />
                      </Form.Group>

                      <Form.Group
                        as={Col}
                        md="4"
                        controlId="registrationNumber"
                      >
                        <Form.Label>Registration Number (Optional)</Form.Label>
                        <Form.Control
                          type="text"
                          name="registrationNumber"
                          value={formData.registrationNumber}
                          onChange={handleChange}
                        />
                      </Form.Group>
                    </Row>

                    <Button variant="primary" type="submit" className="mt-2">
                      Create License
                    </Button>
                  </Form>
                </Card.Body>
              </Card>
            </Col>
          </Row>
        </Container>
      </div>
    </>
  );
}

export default CreateTradeLicense;
